// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1KYFv","amount":"Amount_amount__3oA_C","tip":"Amount_tip__UyTb2","tipHeader":"Amount_tipHeader__98xhX","tipsWrap":"Amount_tipsWrap__pUo1X"};